/**
 *  LOG WARNING
 *  -- common 'warning' function for the store finder
 */
export const warn = msg => console.warn(`CUBE - StoreFinder - ${msg}`); // eslint-disable-line no-console

// API URL : getStoreAvailability
const API_STORE_AVAILABILITY =
  'rest/model/com/decathlon/cube/commerce/inventory/InventoryActor/getStoreAvailability';

// Save all requested product informations
// -- mapProductInfo[model][sku][store] = { product-related information }
export const mapProductInfo = {};

/**
 *  GET PRODUCT INFO
 *  -- for a model / sku and a list of stores
 *  -- get related product informations and save it in productInfo
 */
export const getProductInfo = (idModel, idSku, idStoreList) => {
  // Pre init productInfo for current (model,sku) , if empty
  if (!mapProductInfo[idModel]) mapProductInfo[idModel] = {};
  if (!mapProductInfo[idModel][idSku]) mapProductInfo[idModel][idSku] = {};

  // find store ids that are not already in productInfo
  const idStoreListToSearch = idStoreList.filter(
    id => !mapProductInfo[idModel][idSku][id]
  );

  // if idStoreListToSearch is empty, we already have all info
  // > return directly-resolved promise
  if (idStoreListToSearch.length === 0)
    return Promise.resolve(mapProductInfo[idModel][idSku]);

  // else : call STORE AVAILABILITY API
  // > return a promise & resolve it when the API call succeed
  const url = `${API_STORE_AVAILABILITY}?storeIds=${encodeURIComponent(
    idStoreListToSearch.join(',')
  )}&skuId=${idSku}&modelId=${idModel}&displayStoreDetails=false`;

  // return promise
  return new Promise((resolve, reject) => {
    // call API
    cube.ajax
      .get(url)
      .onSuccess(response => {
        if (response && response.responseTO && response.responseTO.data) {
          // Iterates response and hydrates productInfo object
          response.responseTO.data.forEach(s => {
            mapProductInfo[idModel][idSku][s.storeId] = {};
            // Product ID's
            mapProductInfo[idModel][idSku][s.storeId].idModel = idModel;
            mapProductInfo[idModel][idSku][s.storeId].idSku = idSku;
            // Store Info
            mapProductInfo[idModel][idSku][s.storeId].storeName = s.storeName;
            // Product Info
            mapProductInfo[idModel][idSku][s.storeId].quantity = s.quantity;
            mapProductInfo[idModel][idSku][s.storeId].favoriteStore =
              s.favoriteStore;
            mapProductInfo[idModel][idSku][s.storeId].clickNcollect1h =
              s.clickNcollect1h;
          });
        }
        // resolve promise
        resolve(mapProductInfo[idModel][idSku] || {});
      })
      .onError(reject)
      .call();
  });
};



// WEBPACK FOOTER //
// ./src/commons/component/store-finder/utils.js